import { h } from 'preact';
import PropTypes from 'prop-types';

import { getClassNames } from '../../../../../utils/classnames-utils';

import { modifierList as formsModifierList } from './props-list';

const DEFAULT_CTA_MODIFIERS = [''];

const Forms = ({ children, modifiers = DEFAULT_CTA_MODIFIERS }) => {
  const classNames = getClassNames('c-forms', modifiers);

  return <div className={classNames}>{children}</div>;
};

Forms.propTypes = {
  children: PropTypes.any.isRequired,
  modifiers: PropTypes.arrayOf(PropTypes.oneOf(formsModifierList)),
};

export default Forms;
